import { render, staticRenderFns } from "./CompoundModal.vue?vue&type=template&id=1b9f072e&scoped=true"
import script from "./CompoundModal.vue?vue&type=script&lang=js"
export * from "./CompoundModal.vue?vue&type=script&lang=js"
import style0 from "./CompoundModal.vue?vue&type=style&index=0&id=1b9f072e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9f072e",
  null
  
)

export default component.exports